// Replace your existing SystemAlertsKpiCards component with this updated version

import React from "react";
import { Building, AlertTriangle, DollarSign, Clock } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useRecommendationsDashboardKpis } from "../hooks";
import { useCurrency } from "@shared/selectors/globalSelectors";

export const SystemAlertsKpiCards: React.FC = () => {
  // Fetch real KPI data using the hook
  const { data: kpiData } = useRecommendationsDashboardKpis();
  const currency = useCurrency();

  // Format cost savings value
  const formatCostSavings = (value: number) => {
    const numValue = value;
    return `${currency} ${numValue}`;
  };

  // KPI data using real API response
  const kpiCards = [
    {
      title: "Total Active Recommendations",
      count: kpiData?.results?.totalActiveRecommendations || 0,
      icon: <Building className="h-6 w-6 text-blue-600" />,
      trendSummary: "Active recommendations",
    },
    {
      title: "High-Risk Assets Identified",
      count: kpiData?.results?.highRiskAssetsIdentified || 0,
      icon: <AlertTriangle className="h-6 w-6 text-red-600" />,
      trendSummary: "Require immediate attention",
    },
    {
      title: "Potential Cost Savings",
      count: formatCostSavings(kpiData?.results?.potentialCostSavings),
      icon: <DollarSign className="h-6 w-6 text-green-600" />,
      trendSummary: "Estimated savings",
    },
    {
      title: "Recommendations Overdue",
      count: kpiData?.results?.recommendationsOverdue || 0,
      icon: <Clock className="h-6 w-6 text-orange-600" />,
      trendSummary: "Past due date",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {kpiCards.map((kpi, index) => (
        <QuickStatsCard
          key={index}
          title={kpi.title}
          count={kpi.count}
          trendSummary={kpi.trendSummary}
          icon={kpi.icon}
        />
      ))}
    </div>
  );
};
